@if (campaignsService.errorMsg) {
  <feedback-card feedBackType="error" [message]="campaignsService.errorMsg" />
}

@if (!success) {
  <div class="rvw">
    <!-- What this launch adds up to -->
    <section class="bk-panel rvw__receipt" aria-labelledby="rvw-receipt-title">
      <h2 class="bk-sr-only" id="rvw-receipt-title">At a glance</h2>
      <div class="rvw__figures">
        <div class="rvw__figure" [attr.data-tone]="audience.count === 0 ? 'bad' : null">
          @if (audience.loading && audience.count === null) {
            <span class="bk-skel rvw__skel" aria-label="Counting recipients"></span>
          } @else {
            <span class="rvw__value">{{ audience.count === null ? "—" : formatCount(audience.count) }}</span>
          }
          <span class="rvw__label">unique recipients</span>
        </div>
        <div class="rvw__figure">
          <span class="rvw__value">{{ formatCount(messagesService.savedMessages.length) }}</span>
          <span class="rvw__label">{{ messagesService.savedMessages.length === 1 ? "message" : "messages" }}</span>
        </div>
        <div class="rvw__figure">
          <span class="rvw__value">{{ formatCount(totalSends) }}</span>
          <span class="rvw__label">{{ totalSends === 1 ? "scheduled send" : "scheduled sends" }}</span>
        </div>
        <div class="rvw__figure">
          <span class="rvw__value">
            {{ totalUnits === null ? "—" : (unitsEstimated ? "≈ " : "") + formatCount(totalUnits) }}
          </span>
          <span class="rvw__label">SMS in all</span>
        </div>
      </div>
      <p class="rvw__fine">
        The SMS total is parts × sends × recipients at today’s audience.
        @if (unitsEstimated) {
          Personalized fields change each message’s length, so it is an estimate.
        }
        Contacts added to these groups later can raise it.
      </p>

      @if (audience.failed) {
        <p class="rvw__warn">
          <span class="bk-sym" aria-hidden="true">error</span>
          <span>
            Couldn’t count the recipients.
            <button type="button" class="rvw__link" (click)="audience.refresh(true)">Count again</button>
          </span>
        </p>
      } @else if (audience.count === 0 && !audience.empty) {
        <p class="rvw__warn rvw__warn--quiet">
          <span class="bk-sym" aria-hidden="true">group_off</span>
          <span>
            Added contacts to these groups since?
            <button type="button" class="rvw__link" [disabled]="audience.loading" (click)="audience.refresh(true)">
              {{ audience.loading ? "Counting…" : "Count again" }}
            </button>
          </span>
        </p>
      }

      @if (problems.length) {
        <div class="rvw__problems" role="alert">
          <p class="rvw__problems-title">Fix {{ problems.length === 1 ? "this" : "these" }} before launching</p>
          <ul>
            @for (problem of problems; track $index) {
              <li>
                <span class="bk-sym" aria-hidden="true">error</span>
                <span class="rvw__problem-text">{{ problem.text }}</span>
                <button type="button" class="rvw__link" (click)="goToStep(problem.step)">{{ problem.action }}</button>
              </li>
            }
          </ul>
        </div>
      }
    </section>

    <!-- Every step, each with a way back to change it -->
    <section class="bk-panel rvw__sections" aria-labelledby="rvw-sections-title">
      <h2 class="bk-sr-only" id="rvw-sections-title">Campaign settings</h2>
      <app-campaign-details-review [campaignDetails]="campaignDetailsService.campaignDetails"></app-campaign-details-review>
      <app-recipients-review
        [recipients]="recipientsService.recipients"
        [totalContacts]="recipientsService.totalRecipientsCount"
      ></app-recipients-review>
      <app-message-review [messages]="messagesService.savedMessages"></app-message-review>
      <app-schedule-review
        [campaignSchedule]="scheduleService.campaignSchedule"
        [messageSchedule]="scheduleService.messageSchedule"
      ></app-schedule-review>
    </section>

    <!-- actions -->
    <div class="rvw__foot">
      <button type="button" class="bk-btn bk-btn--ghost" (click)="this.cancelCampaignService.openCancelModal()">
        Cancel
      </button>
      <div class="rvw__foot-end">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="goToStep('schedule')">Back</button>
        <button
          type="button"
          class="bk-btn bk-btn--primary"
          [disabled]="campaignsService.isLoading || problems.length > 0"
          [attr.aria-busy]="campaignsService.isLoading || null"
          (click)="submitCampaign()"
        >
          @if (campaignsService.isLoading) {
            <span class="bk-skel rvw__busy" aria-hidden="true"></span>
            Launching…
          } @else {
            <span class="bk-sym" aria-hidden="true">rocket_launch</span>
            Launch campaign
          }
        </button>
      </div>
    </div>
  </div>
} @else {
  <!-- Launched -->
  <div class="rvw__done" role="status">
    <span class="rvw__done-mark" aria-hidden="true">
      <span class="bk-sym">check</span>
    </span>
    <h2 class="bk-heading rvw__done-title">Campaign launched</h2>
    <p class="rvw__done-text">
      <strong>{{ launchedName || "Your campaign" }}</strong> is saved and its messages are scheduled. Taking you
      to your campaigns…
    </p>
  </div>
}
